var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7179 3.30385C15.1024 3.70034 15.0926 4.33343 14.6961 4.7179L6.44615 12.7179C6.05826 13.094 5.44174 13.094 5.05386 12.7179L1.30385 9.08154C0.907369 8.69707 0.89763 8.06398 1.2821 7.66749C1.66657 7.27101 2.29966 7.26127 2.69615 7.64574L5.75 10.607L13.3039 3.2821C13.7003 2.89763 14.3334 2.90737 14.7179 3.30385Z",
    fill: "#F3AC3C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/iconCheck.92765b88aa0e04d0b42f24e65fae658d.svg";
export { ForwardRef as ReactComponent };